export default (uri, key) => {
  const re = new RegExp(`[?&]${key}=([^&#]*)`, 'i');
  const match = uri && uri.match(re);
  return match ? decodeURI(match[1]) : null;
};
